import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, COMPANY } from "../lib/constants";
import Logo from "./Logo";

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-soft">
      <div className="container-x flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="brand-link">
          <Logo size={40} tone="auto" />
          <div className="leading-tight whitespace-nowrap">
            <div className="text-[15px] font-bold text-navy">Melopa Invents</div>
            <div className="text-[10px] uppercase tracking-widest text-[var(--melopa-gold)] font-semibold">Pvt Ltd</div>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-0.5 xl:gap-1" data-testid="main-nav">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-2.5 xl:px-3 py-2 rounded-md text-[12.5px] xl:text-[13px] font-semibold whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-navy bg-[#f1f5f9]"
                    : "text-[var(--melopa-muted)] hover:text-navy hover:bg-[#f8fafc]"
                }`
              }
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
            >
              {l.short || l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          <a href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`} className="btn-outline text-[13px]" data-testid="header-call">
            Call
          </a>
          <Link to="/submit" className="btn-gold text-[13px]" data-testid="header-submit">
            Submit Requirement
          </Link>
        </div>
        <button
          className="lg:hidden p-2 rounded-md border border-soft"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-soft bg-white">
          <div className="container-x py-3 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium ${
                    isActive ? "text-navy bg-[#f1f5f9]" : "text-[var(--melopa-muted)] hover:bg-[#f8fafc]"
                  }`
                }
                data-testid={`mnav-${l.to.replace("/", "") || "home"}`}
              >
                {l.label}
              </NavLink>
            ))}
            <div className="flex gap-2 mt-2">
              <a href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`} className="btn-outline flex-1 justify-center text-sm">
                Call
              </a>
              <Link to="/submit" className="btn-gold flex-1 justify-center text-sm" onClick={() => setOpen(false)}>
                Submit Requirement
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
